<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <!-- <h4 class="color-secundary">Base garantizados</h4> -->
      <p class="mb-5 text-justify">
        <!-- <b>Icono circular:</b> a través de esta opcíón, se puede descargar la base de garantizados al último corte contable.
        <br />-->
        <b>Filtro:</b> a través de esta opcíón, se puede visualizar las facturas generadas, en un periodo de
        tiempo determinado.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        :dataLength="dataLength"
        @click-buscar="getFacturas"
        @click-event="clickEvent"
        filtro
        pagination
        :showFilterDates="true"
        :showFilterEstadoGarantia="true"
        :showFilterConvenios="true"
        :showExportToExcel="true"
        :EstadoGarantia="Estados"
        :Convenios="convenios"
        :perPage="perPage"
        
      >
        <table-column
          slot="label"
          :label="'Tipo'"
          v-bind:value="'tipo_factura'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'# de factura'"
          v-bind:value="'sap_numero_factura'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha facturacion'"
          v-bind:value="'fecha_facturacion'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Vencimiento'"
          v-bind:value="'fecha_vencimiento'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor'"
          v-bind:value="'valor_neto'"
          :customClass="'text-center'"
          :filter="'numberFormat'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Iva'"
          v-bind:value="'valor_iva'"
          :customClass="'text-center'"
          :filter="'numberFormat'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Total'"
          v-bind:value="'valor_total'"
          :customClass="'text-center'"
          :filter="'numberFormat'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado_sap'"
          :customClass="'text-center'"
        ></table-column>
        
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileSaver from "file-saver";
//import FileSaver from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      fecha_inicio: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      fecha_fin: this.$moment().format("YYYY-MM-DD"),
      checkEstado: true,
      Estados: [
        { value: null, text: "Estado", disabled: true },
        { value: "PENDIENTE_PAGO", text: "PENDIENTE_PAGO" },
        { value: "PAGADO", text: "PAGADO" }
      ],
      
      estadoSelected: null,
      modelo: null,
      convenio: null,
      perPage: 6,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      echo: "echo",
      api: "api",
    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "Código", disabled: true });
      return data;
    },
    dataLength() {
      return this.$store.getters["pages/dataInformes"].paginacion.total;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    total() {
      return this.$store.getters["pages/total"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    }
  },
  methods: {
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
      }
    },
    getFacturas(params) {
      console.log("params",params)
      this.fecha_inicio = params.fecha_inicio;
      this.fecha_fin = params.fecha_fin;
      this.convenio = params.convenio;
      this.estadoSelected = params.filterEstadoGarantiaSelected;
      this.perPage = params.nRows;
      this.loadData();
    },
    loadData(row, page, paginar = true) {
      this.$store.dispatch("pages/fetch", {
        endpoint: "informes/estado_facturas",
        params: {
          row: this.perPage,
          page: page ? page : 1,
          paginar: paginar,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          convenio: this.convenio,
          estado:this.estadoSelected
        },
      });
    },
  },
  mounted() {
    this.$store.dispatch("pages/fetchConvenios", {
      endpoint: "informes/convenio",
    });
  },
};
</script>
